<template>
  <v-dialog v-model="isShow" persistent fullscreen>
    <v-card style="height: 98dvh !important">
      <v-layout>
        <v-flex>
          <div class="primary--text headline pa-2">{{ $t('Upload File') }}</div>
        </v-flex>
        <v-flex>
          <div class="text-xs-right">
            <v-btn flat fab small @click="handleClose">
              <v-icon>close</v-icon>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
      <iframe
        v-if="renderIframe"
        ref="iframe"
        sandbox="allow-popups allow-forms allow-same-origin allow-scripts allow-top-navigation allow-downloads"
        allowfullscreen="true"
        :src="src"
        style="
          height: calc(100% - 64px);
          overflow: auto;
          width: 100%;
          border: none;
          position: absolute;
          inset: 60px 0 0;
        "
      />
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    value: {
      default: false,
      type: Boolean
    },
    type: {
      type: String,
      default: 'image'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number,
      default: undefined
    },
    urls: {
      type: Array,
      default: undefined
    }
  },
  data() {
    return {
      isShow: this.value,
      renderKey: Date.now(),
      renderIframe: false
    }
  },
  computed: {
    ...mapGetters(['currentLang']),
    src() {
      if (!this.currentLang) return ''
      return `https://cms.enterprise.zwiz.app/${this.currentLang}/drive-upload-iframe?inputType=${this.type}&multipleFile=${this.multiple}&max=${this.max}&timestamp=${this.renderKey}`
    }
  },
  watch: {
    value(isOpen) {
      this.isShow = isOpen
      if (isOpen) {
        this.renderKey = Date.now()
        setTimeout(() => {
          this.renderIframe = true
        })
      } else {
        setTimeout(() => {
          this.renderIframe = false
        }, 300)
      }
    },
    renderIframe: {
      immediate: true,
      handler(value) {
        if (value) {
          window.addEventListener('message', this.handleMessage)
        } else {
          window.removeEventListener('message', this.handleMessage)
        }
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage)
  },
  methods: {
    handleClose() {
      this.isShow = false
      this.$emit('close')
    },
    handleMessage(event) {
      if (event.data) {
        this.handleListenEventMessage(event.data)
      }
    },
    handleListenEventMessage({ event_id, value }) {
      try {
        if (event_id === 'drive_upload_ready') {
          if (this.urls) {
            this.$refs.iframe.contentWindow.postMessage(
              {
                event_id: 'init_selected_files',
                value: this.urls
              },
              '*'
            )
          }
        }
        if (event_id === 'send_file_drive_payload') {
          this.$emit('upload', this.multiple ? value.map((item) => item.url) : value[0].url)
          if (value.every((item) => item.url)) this.handleClose()
        }
        if (event_id === 'select_file_drive_payload') {
          this.$emit('upload', this.multiple ? value.map((item) => item.url) : value[0].url)
          if (value.every((item) => item.url)) this.handleClose()
        }
        if (event_id === 'copy_to_clipboard') {
          navigator.clipboard.writeText(value)
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/intent/Dialog/UploadFileDrive.vue